/**
 * Variant chip selector na product-card (archive / homepage / related).
 *
 * Listenuje na klik `.hn-product-card__variant` w `[data-hn-variants]` wrapperze.
 * Po kliknięciu:
 *   1. Toggle `is-active` w grupie chipów (jeden aktywny per `data-attr-key`)
 *   2. Build current combo ze wszystkich aktywnych chipów na karcie
 *   3. Znajdź matching variation w `data-hn-variations` payload (article root)
 *   4. Update `[data-hn-price]` innerHTML z variation.price_html
 *   5. Update `[data-hn-cta]` `data-variation_id` + `href` żeby add-to-cart trafiło
 *      do właściwej variacji
 *
 * Payload format (per article `data-hn-variations`):
 *   [{id: 123, attrs: {attribute_pa_waga: '12kg'}, price_html: '...', in_stock: true, add_url: '...'}]
 *
 * Default combo (per article `data-hn-default`):
 *   {attribute_pa_waga: '12kg', attribute_pa_smak: 'kurczak'}
 */

function buildCurrentCombo(card) {
    const combo = {};
    card.querySelectorAll('[data-hn-variants]').forEach((group) => {
        const active = group.querySelector('.hn-product-card__variant.is-active');
        if (!active) return;
        const key = active.dataset.attrKey;
        const val = active.dataset.attrValue;
        if (key && val) combo[key] = val;
    });
    return combo;
}

function findMatchingVariation(card, combo) {
    let variations;
    try { variations = JSON.parse(card.dataset.hnVariations || '[]'); }
    catch (_) { return null; }
    if (!Array.isArray(variations)) return null;

    return variations.find((v) => {
        const attrs = v.attrs || {};
        // Each combo key must match (puste w attrs traktujemy jako wildcard — "any").
        for (const k in combo) {
            if (attrs[k] && attrs[k] !== combo[k]) return false;
        }
        return true;
    }) || null;
}

function updateCardForVariation(card, variation) {
    if (!variation) return;

    // 1. Update price
    const priceEl = card.querySelector('[data-hn-price]');
    if (priceEl && variation.price_html) {
        priceEl.innerHTML = variation.price_html;
    }

    // 2. Update CTA (variation_id + href)
    const cta = card.querySelector('[data-hn-cta]');
    if (cta) {
        cta.dataset.variation_id = String(variation.id || 0);
        if (variation.add_url) cta.setAttribute('href', variation.add_url);
        // OOS state — czytamy z in_stock flagi z payload.
        if (variation.in_stock === false) {
            cta.classList.add('hn-product-card__cta--out');
            cta.setAttribute('aria-disabled', 'true');
        } else {
            cta.classList.remove('hn-product-card__cta--out');
            cta.removeAttribute('aria-disabled');
        }
    }
}

function handleChipClick(chip) {
    const card = chip.closest('[data-product-id]');
    if (!card) return;

    // OOS chip nie reaguje.
    if (chip.classList.contains('is-oos')) return;

    const group = chip.closest('[data-hn-variants]');
    if (!group) return;

    // Toggle: clear sibling chips w tej samej grupie, dodaj is-active do clicked.
    group.querySelectorAll('.hn-product-card__variant.is-active').forEach((c) => {
        c.classList.remove('is-active');
    });
    chip.classList.add('is-active');

    // Build current combo + find matching variation + update card.
    const combo = buildCurrentCombo(card);
    const variation = findMatchingVariation(card, combo);
    updateCardForVariation(card, variation);
}

export function initCardVariantSelector() {
    // Event delegation — działa na nowych kartach renderowanych po AJAX (np. fkcart upsell).
    document.addEventListener('click', (e) => {
        const chip = e.target.closest('.hn-product-card__variant');
        if (!chip) return;

        // Tylko jeśli chip jest w wrapperze `[data-hn-variants]` — żeby nie kolidować
        // z innymi przyciskami które przypadkiem mają tę klasę gdzieś indziej.
        if (!chip.closest('[data-hn-variants]')) return;

        e.preventDefault();
        handleChipClick(chip);
    });
}
